<div class="add-new-report-wrapper">
  @if (showMenu) {
  <div class="dropdown-backdrop" (click)="showMenu = false"></div>
  }
  <div class="report-type-btn-group">
    <button
      type="button"
      class="uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
      (mouseover)="showMenu = true"
    >
      Add Report
    </button>
    @if (showMenu && reportTypes.length > 0) {
    <div class="report-type-menu">
      @for (type of reportTypes; track type) {
      <div class="report-type-item" (click)="selectReportType(type)">
        {{ type?.toLowerCase() == 'inbuilt' ? 'In-Built' : type }}
      </div>
      }
    </div>
    }
  </div>
</div>

<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #addReportPopup
  class="modal-demo lookup-editor-section-modal"
  (closeModal)="closeModal()"
>
  <ng-container class="app-modal-header"
    >{{ editFlag ? 'Edit Report' : 'Add Report' }} —
    {{ selectedReportType.toLowerCase() == 'inbuilt' ? 'In-Built' : selectedReportType }}</ng-container
  >
  <ng-container class="app-modal-body">
    @if (isAddReportPopupOpen) {
    <app-inbuilt-editor
      [menuItems]="menuItems"
      [initialJson]="reportJson"
      [jsonType]="'parent'"
      [showActionButtons]="false"
      [readOnly]="readOnly"
      (jsonTextChange)="onJsonTextChange($event)"
    >
      <app-add-report
        [dataToEdit]="dataToEdit"
        [editFlag]="editFlag"
        [formfields]="formfields"
        [tableName]="tableName"
        [closePopup]="closePopup"
        [reportType]="selectedReportType"
        [reportCategoryList]="reportCategoryList"
        [jsonChanged]="isJsonChanged"
        (emitReqPayload)="onReportSubmit($event)"
      >
      </app-add-report>
    </app-inbuilt-editor>
    }
  </ng-container>
</app-modal>
